"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _asyncIterableStartsWith_ = require("./async-iterable-starts-with_");

var _default = {
  asyncStartsWith_: _asyncIterableStartsWith_.asyncIterableStartsWith_
};
exports.default = _default;
module.exports = exports["default"];